const apiConfigs = {
    HTTPS: "https://",
    APPURL: "https://app",
    BASEURL: "api.convin.ai",
};

export default apiConfigs;
